import { render, staticRenderFns } from "./techCenter.vue?vue&type=template&id=8c41ea92&scoped=true&"
import script from "./techCenter.vue?vue&type=script&lang=js&"
export * from "./techCenter.vue?vue&type=script&lang=js&"
import style0 from "./techCenter.vue?vue&type=style&index=0&id=8c41ea92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c41ea92",
  null
  
)

export default component.exports